/* 旧サイトファイルPath：/lp/decor/js/common.js */

var pp = 0;
if ($(".hdrFixed").length) {
	pp = $(".hdrFixed").height();
} else {
	var ua = navigator.userAgent;
	// 繧ｿ繝悶Ξ繝�ヨ繝ｻ繧ｹ繝槭�繝医ヵ繧ｩ繝ｳ譎�
	if (
		((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
		ua.indexOf("Mobile") > 0) ||
		ua.indexOf("iPad") > 0
	) {
		if ($(".hdrFixed--sp").length) {
			pp = $(".hdrFixed--sp").height();
		}
		// PC
	} else {
		if ($(".hdrFixed--pc").length) {
			pp = $(".hdrFixed--pc").height();
		}
	}
}
$(function(){
	$('a[href*=\\#]:not([href=\\#])').on('click',function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			if ($target.length) {
				if($(this).parents('.menuBox').length){
					setTimeout(function(){
						var targetOffset = $target.offset().top;
						$('html,body').animate({scrollTop: targetOffset-pp}, 1000);
					},100);
				}else{
					var targetOffset = $target.offset().top;
					$('html,body').animate({scrollTop: targetOffset-pp}, 1000);
				}
				return false;
			}
		}
	});

});

$(window).on('load',function(){
	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){	
		localLink = localLink.slice(localLink.indexOf("#")+1);
		$('html,body').animate({scrollTop: $('#'+localLink).offset().top-pp}, 500);
	}
});